type EnumValue = string | number | null;

export class Enum {
    static fromValue(value: EnumValue) {
        const item = this.items.find(item => item.id === value);
        return new this(value, item?.name || 'Не определено');
    }

    value: EnumValue = '';
    name: string = '';

    constructor(value: EnumValue, name = '') {
        this.value = value;
        this.name = name;
    }

    is = (value: EnumValue) => this.value === value;
    in = (values: EnumValue[]) => values.indexOf(this.value) > -1;

    static items: {
        id: string;
        name: string;
    }[] = [];
}
